let defaultDistanceToLoadOffSection;
if (window.innerWidth < 1300) {
  defaultDistanceToLoadOffSection = 1000;
} else {
  defaultDistanceToLoadOffSection = 1500;
}

async function lazyLoadSectionFiles(sectionElement, lazyLoadImages, lazyLoadPictures, lazyLoadLottieFiles, distanceToLoadOffSection = defaultDistanceToLoadOffSection) {
  const sectionLoadingObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;

      // console.log('Lazy load: ', sectionElement);
    
      if (lazyLoadPictures) lazyLoadPictures.forEach(preloadPicture);
      
      if (lazyLoadImages) lazyLoadImages.forEach(preloadImage);
      
      // if (lazyLoadImages) {
      //   loadImages(lazyLoadImages).then(() => {
      //     // console.log('All images loaded in section: ', sectionElement);
      //   }).catch((error) => {
      //     console.error('Error loading image: ', error);
      //   });
      // }


      if (lazyLoadLottieFiles) lazyLoadLottieFiles.forEach(preloadLottieFile);
      
      sectionLoadingObserver.unobserve(sectionElement);
    });
  }, { rootMargin: `${distanceToLoadOffSection}px 0px` });
  sectionLoadingObserver.observe(sectionElement);
}

function preloadLottieFile(lottieData) {
  const {lottiePlayer, lottieFileName} = lottieData;

  if (lottiePlayer && lottieFileName) {
    lottiePlayer.load(lottieFileName);
  }
}

function preloadPicture(picture) {
  let sources = picture.getElementsByTagName('source');
  let img = picture.getElementsByTagName('img')[0];

  // Replace the srcset of each source with the real image url
  for (let source of sources) {
    source.srcset = source.dataset.srcset;
  }

  // Replace the img src as a fallback
  img.src = img.dataset.src;
}

function preloadImage(img) {
  if (img.dataset.srcset) {
    img.srcset = img.dataset.srcset;
  }
  img.src = img.dataset.src;
}

// async function loadImage(img) {
//   return new Promise((resolve, reject) => {
//     img.onload = () => resolve(true);
//     img.onerror = () => reject(new Error('Failed to load image'));
//     if (img.dataset.srcset) {
//       img.srcset = img.dataset.srcset;
//     }
//     img.src = img.dataset.src;
//   });
// }

// async function loadImages(images) {
//   for (const img of images) {
//     await loadImage(img);
//   }
// }